"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printEffect = exports.ColorByEffect = exports.EffectPrinters = exports.EffectPrinterApex = exports.EffectPrinterHotStreak = exports.EffectPrinterDamageAmplify = exports.EffectPrinterName = void 0;
const EffectType_1 = require("../core/effects/EffectType");
const Attributes_1 = require("./Attributes");
const GlassCannon_1 = require("../core/effects/core/GlassCannon");
const BadLuck_1 = require("../core/effects/core/BadLuck");
const MasterSharpshooter_1 = require("../core/effects/core/MasterSharpshooter");
const MasterOfPoisons_1 = require("../core/effects/core/MasterOfPoisons");
const HuntersSupremacy_1 = require("../core/effects/core/HuntersSupremacy");
const KillingMachine_1 = require("../core/effects/core/KillingMachine");
const MarkOfTheKunir_1 = require("../core/effects/core/MarkOfTheKunir");
const Stardust_1 = require("../core/effects/core/Stardust");
const Bloodlust_1 = require("../core/effects/core/Bloodlust");
const CyndineSoulHarvest_1 = require("../core/effects/core/CyndineSoulHarvest");
const BloodSignet_1 = require("../core/effects/core/BloodSignet");
const Dampened_1 = require("../core/effects/core/Dampened");
const Record_1 = require("../utils/Record");
const enums_1 = require("../core/enums");
const AbilityMetas_1 = require("./AbilityMetas");
const Enum_1 = require("../utils/Enum");
const EffectPrinterEmpty = () => "";
const EffectPrinterAttribute = (action, type, effect) => {
    if ((0, Record_1.getValueOrDefault)(Attributes_1.AttributeIsSkipped, effect.attribute, false)) {
        return "";
    }
    const plus = action === "apply" ? "+"
        : "-";
    const minus = action === "apply" ? "-"
        : "+";
    return `$plusOrMinus $attribute ($amount)`
        .replace("$plusOrMinus", EffectType_1.EffectType[type].includes("Decrease") ? minus : plus)
        .replace("$attribute", enums_1.AttributeType[effect.attribute])
        .replace("$amount", effect.amount.toLocaleString());
};
const EffectPrinterAttributePercent = (action, type, effect) => {
    if ((0, Record_1.getValueOrDefault)(Attributes_1.AttributeIsSkipped, (0, Enum_1.enumValue)(enums_1.AttributeType, effect.attribute), false)) {
        return "";
    }
    const plus = action === "apply" ? "+"
        : "-";
    const minus = action === "apply" ? "-"
        : "+";
    return `$plusOrMinus $attribute ($amount%)`
        .replace("$plusOrMinus", EffectType_1.EffectType[type].includes("Decrease") ? minus : plus)
        .replace("$attribute", (0, Enum_1.enumKey)(enums_1.AttributeType, effect.attribute))
        .replace("$amount", effect.percentOfBase.toLocaleString());
};
const EffectPrinterDoT = (action, type, effect) => {
    const plusOrMinus = action === "apply" ? "+"
        : "-";
    return `${plusOrMinus} ${effect.name} (${effect.primaryAttribute})`;
};
const EffectPrinterHoT = (action, type, effect) => {
    const plusOrMinus = action === "apply" ? "+"
        : "-";
    return `${plusOrMinus} ${EffectType_1.EffectType[type]} (${effect.amountPerTurn})`;
};
const EffectPrinterStackable = (action, type, effect) => {
    const plusOrMinus = action === "apply" ? "+"
        : "-";
    const percent = type === EffectType_1.EffectType.Vulnerability ? 5
        : 10;
    return `${plusOrMinus} ${effect.name} (${effect.stacks * percent}%)`;
};
const EffectPrinterAbilityDisabled = (action, type, effect, appliedTo, slice) => {
    var _a;
    const actor = slice[appliedTo];
    const ability = (0, Record_1.getValueOrDefault)((actor === null || actor === void 0 ? void 0 : actor.abilities) || {}, effect.slot, undefined);
    const abilityName = ((_a = (0, Record_1.getValueOrDefault)(AbilityMetas_1.AbilityMetas, ability === null || ability === void 0 ? void 0 : ability.abilityType, undefined)) === null || _a === void 0 ? void 0 : _a.name) || "Ability";
    if (action === "apply") {
        return `+ ${abilityName} Disabled`;
    }
    else {
        return `- ${abilityName} Disabled`;
    }
};
const EffectPrinterCustomText = text => (action, type, effect) => {
    if (action === "apply") {
        return `+ ${text}`;
    }
    else {
        return `- ${text}`;
    }
};
const EffectPrinterName = (action, type, effect) => {
    const plusOrMinus = action === "apply" ? "+"
        : "-";
    return `${plusOrMinus} ${effect.name || effect.__typeName}`;
};
exports.EffectPrinterName = EffectPrinterName;
const EffectPrinterDamageAmplify = (action, type, effect) => {
    const plusOrMinus = action === "apply" ? "+"
        : "-";
    const amount = effect.damageAmplificationPercentOverride;
    return `${plusOrMinus} ${amount}% Damage Amplification`;
};
exports.EffectPrinterDamageAmplify = EffectPrinterDamageAmplify;
const EffectPrinterHotStreak = (action, type, effect) => {
    const plusOrMinus = action === "apply" ? "+"
        : "-";
    const amount = effect.percentIncrease;
    return `${plusOrMinus} ${amount}% Damage`;
};
exports.EffectPrinterHotStreak = EffectPrinterHotStreak;
const EffectPrinterApex = (action, type, effect) => {
    const plusOrMinus = action === "apply" ? "+"
        : "-";
    const amount = effect.percentIncrease;
    return `${plusOrMinus} ${amount}% Crit Chance`;
};
exports.EffectPrinterApex = EffectPrinterApex;
exports.EffectPrinters = {
    [EffectType_1.EffectType.ApplyVfx]: EffectPrinterEmpty,
    [EffectType_1.EffectType.TurnMeterIncrease]: EffectPrinterEmpty,
    [EffectType_1.EffectType.TurnMeterDecrease]: EffectPrinterEmpty,
    [EffectType_1.EffectType.Damage]: EffectPrinterEmpty,
    [EffectType_1.EffectType.DoTDamage]: EffectPrinterEmpty,
    [EffectType_1.EffectType.Healing]: EffectPrinterEmpty,
    [EffectType_1.EffectType.HoTHealing]: EffectPrinterEmpty,
    [EffectType_1.EffectType.Death]: EffectPrinterCustomText("Dead"),
    [EffectType_1.EffectType.Confused]: EffectPrinterCustomText("60% Chance to Miss"),
    [EffectType_1.EffectType.MeltedArmor]: EffectPrinterCustomText("10% Fire Vulnerability, -10 ARMOR"),
    [EffectType_1.EffectType.SignaExDiris]: EffectPrinterCustomText("Death is coming..."),
    [EffectType_1.EffectType.GlassCannon]: EffectPrinterCustomText(GlassCannon_1.GlassCannonEffectArgs.CustomText),
    [EffectType_1.EffectType.BadLuck]: EffectPrinterCustomText(BadLuck_1.BadLuckEffectArgs.CustomText),
    [EffectType_1.EffectType.MasterSharpshooter]: EffectPrinterCustomText(MasterSharpshooter_1.MasterSharpshooterEffectArgs.CustomText),
    [EffectType_1.EffectType.KillingMachine]: EffectPrinterCustomText(KillingMachine_1.KillingMachineEffectArgs.CustomText),
    [EffectType_1.EffectType.HuntersSupremacy]: EffectPrinterCustomText(HuntersSupremacy_1.HuntersSupremacyEffectArgs.CustomText),
    [EffectType_1.EffectType.MasterOfPoisons]: EffectPrinterCustomText(MasterOfPoisons_1.MasterOfPoisonsEffectArgs.CustomText),
    [EffectType_1.EffectType.MarkOfTheKunir]: EffectPrinterCustomText(MarkOfTheKunir_1.MarkOfTheKunirEffectArgs.CustomText),
    [EffectType_1.EffectType.Stardust]: EffectPrinterCustomText(Stardust_1.StardustEffectArgs.CustomText),
    [EffectType_1.EffectType.Bloodlust]: EffectPrinterCustomText(Bloodlust_1.BloodlustEffectArgs.CustomText),
    [EffectType_1.EffectType.BloodSignet]: EffectPrinterCustomText(BloodSignet_1.BloodSignetEffectArgs.CustomText),
    [EffectType_1.EffectType.CyndineSoulHarvest]: EffectPrinterCustomText(CyndineSoulHarvest_1.CyndineSoulHarvestEffectArgs.CustomText),
    [EffectType_1.EffectType.Dampened]: EffectPrinterCustomText(Dampened_1.DampenedEffectArgs.CustomText),
    [EffectType_1.EffectType.Dizzy]: EffectPrinterCustomText("Definitely going to miss."),
    [EffectType_1.EffectType.HealingRhythm]: EffectPrinterCustomText("Heals all allies for 5% of focus"),
    [EffectType_1.EffectType.ReciprocateAttack]: (action, type, effect) => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        return `${plusOrMinus} Applies ${effect.effect.name} to attackers`;
    },
    [EffectType_1.EffectType.ReciprocateDeath]: (action, type, effect) => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        return `${plusOrMinus} Applies ${effect.effect.name} to destroyer`;
    },
    [EffectType_1.EffectType.PassiveBuff]: (action, type, effect) => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        return `${plusOrMinus} ${effect.metaText}`;
    },
    [EffectType_1.EffectType.EffectOnHit]: (action, type, effect) => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        return `${plusOrMinus} ${effect.metaText}`;
    },
    [EffectType_1.EffectType.LinkedEventHandler]: (action, type, effect) => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        return `${plusOrMinus} ${effect.metaText}`;
    },
    [EffectType_1.EffectType.Leech]: (action, type, effect) => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        const selfOrAllies = effect.taget.type === enums_1.TargetType.AllAllies ? " allies"
            : effect.taget.type === enums_1.TargetType.Self ? " self"
                : "";
        return `${plusOrMinus} Heals${selfOrAllies} for ${effect.percent}% of damage dealt`;
    },
    [EffectType_1.EffectType.RecentlyStunned]: action => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        return `${plusOrMinus} 25% Stun Immunity`;
    },
    [EffectType_1.EffectType.Darkness]: (action, type, effect) => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        return `${plusOrMinus} ${Math.min(50, effect.stacks * 5)}% Chance to Miss`;
    },
    [EffectType_1.EffectType.DamageAbsorb]: (action, type, effect) => {
        const plusOrMinus = action === "apply" ? "+"
            : "-";
        const remaining = Object.values(effect.damages)
            .concat(effect.totalAbsorb)
            .reduce((last, next) => Math.min(last, next));
        return `${plusOrMinus} ${EffectType_1.EffectType[type]} (${remaining})`;
    },
    [EffectType_1.EffectType.Vulnerability]: EffectPrinterStackable,
    [EffectType_1.EffectType.Haste]: EffectPrinterStackable,
    [EffectType_1.EffectType.Slow]: EffectPrinterStackable,
    [EffectType_1.EffectType.HotStreak]: exports.EffectPrinterHotStreak,
    [EffectType_1.EffectType.Apex]: exports.EffectPrinterApex,
    [EffectType_1.EffectType.DamageAmplify]: exports.EffectPrinterDamageAmplify,
    [EffectType_1.EffectType.MaxAttributeIncrease]: EffectPrinterAttribute,
    [EffectType_1.EffectType.MaxAttributeDecrease]: EffectPrinterAttribute,
    [EffectType_1.EffectType.Regeneration]: EffectPrinterHoT,
    [EffectType_1.EffectType.Bleeding]: EffectPrinterDoT,
    [EffectType_1.EffectType.Burning]: EffectPrinterDoT,
    [EffectType_1.EffectType.Curse]: EffectPrinterDoT,
    [EffectType_1.EffectType.Chill]: EffectPrinterDoT,
    [EffectType_1.EffectType.Diseased]: EffectPrinterDoT,
    [EffectType_1.EffectType.Poisoned]: EffectPrinterDoT,
    [EffectType_1.EffectType.BurningLight]: EffectPrinterDoT,
    [EffectType_1.EffectType.EternalDarkness]: EffectPrinterDoT,
    [EffectType_1.EffectType.SoulDrain]: EffectPrinterDoT,
    [EffectType_1.EffectType.Convulsions]: EffectPrinterDoT,
    [EffectType_1.EffectType.FrostBitten]: EffectPrinterDoT,
    [EffectType_1.EffectType.Withering]: EffectPrinterDoT,
    [EffectType_1.EffectType.DisableAbility]: EffectPrinterAbilityDisabled,
};
exports.ColorByEffect = {
    // Dots
    "Burning": "red",
    "Chill": "blue",
    "Bleeding": "red",
    "Poisoned": "green",
    "Curse": "purple",
    "Diseased": "black",
    "BurningLight": "yellow",
    "EternalDarkness": "black",
    "SignaExDiris": "purple",
    // vulnerability
    // Stacks
    "CurseSiphon": "purple",
    "Stun": "brown",
    "Hoodoo": "purple",
    "Possessed": "purple",
    "Slow": "purple",
    "ArcaneResidue": "purple",
};
function printEffect(action, effect, appliedTo, slice) {
    return [
        (0, Record_1.getValueOrDefault)(exports.EffectPrinters, effect.__type, exports.EffectPrinterName)(action, effect.__type, effect, appliedTo, slice),
        (0, Record_1.getValueOrDefault)(exports.ColorByEffect, effect.__typeName, "white")
    ];
}
exports.printEffect = printEffect;
